module.exports = __webpack_public_path__ + "img/index3_1.81c9423.png";